import { useCallback, useState } from 'react';
import { MatchingOperator } from '../../../../../../constants';
import type { Group } from '../../../../../../types';
import type { UnifiedDrawerActionsProps } from '../types';

export const useLookalikeDrawerActions = ({
  drawerState,
  setDrawerState,
  values,
  segments,
  hasSelectedItemsChanged,
  enforceMarketUnionAfterApply,
}: UnifiedDrawerActionsProps) => {
  const [showDiscardModal, setShowDiscardModal] = useState(false);

  const onApply = useCallback(() => {
    const lookalikeSegments = segments.lookalike || [];

    const updatedGroup: Group = {
      ...values,
      operator: values?.operator ?? MatchingOperator.UNION,
      lookalike: {
        segments: lookalikeSegments,
        operator: values?.lookalike?.operator ?? MatchingOperator.UNION,
      },
    };

    if (lookalikeSegments.length > 0) {
      drawerState.onExpandSection();
    }

    drawerState.updater(updatedGroup);

    setDrawerState({ isOpen: false });

    enforceMarketUnionAfterApply?.(drawerState.fieldPath);
  }, [values, segments.lookalike, drawerState, setDrawerState, enforceMarketUnionAfterApply]);

  const onClose = useCallback(() => {
    if (hasSelectedItemsChanged) {
      setShowDiscardModal(true);
    } else {
      setDrawerState({ isOpen: false });
    }
  }, [hasSelectedItemsChanged, setDrawerState]);

  const onDiscardConfirm = useCallback(() => {
    setShowDiscardModal(false);
    setDrawerState({ isOpen: false });
  }, [setDrawerState]);

  const onDiscardCancel = useCallback(() => {
    setShowDiscardModal(false);
  }, []);

  return {
    showDiscardModal,
    onApply,
    onClose,
    onDiscardConfirm,
    onDiscardCancel,
  };
};
